import classNames from 'classnames';
import styles from './FJEllipsisLoading.module.less';
const FJEllipsisLoading = props => {
    const { className } = props;
    return (
        <div className={classNames(className, styles.lds_ellipsis)}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};
export default FJEllipsisLoading;
